import { ButtonList } from '@dixa/lib-shared-habla';
import { ArticleMoveModal } from 'collection/pages/collectionEdit/components/modals/articleMoveModal';
import { buildArticleEditorUrl } from 'components/articlesTable/utils';
import { useModal } from 'lib-knowledge-modal';
import { useNavigate } from 'react-router-dom';

type ArticlesTableDropdownsProps = {
  articleId: string;
  collectionId: string | undefined;
  isSyncedWithElevio: boolean;
};

/** Action dropdowns for articles */
export function ArticlesTableDropdowns({
  articleId,
  collectionId,
  isSyncedWithElevio,
}: ArticlesTableDropdownsProps): JSX.Element | null {
  const navigate = useNavigate();

  return (
    <ButtonList>
      <ButtonList.Item
        icon="pen"
        onClick={() => navigate(buildArticleEditorUrl({ articleId }))}
      >
        Edit
      </ButtonList.Item>
      <ArticleActionButtons
        articleId={articleId}
        collectionId={collectionId}
        isSyncedWithElevio={isSyncedWithElevio}
      />
    </ButtonList>
  );
}
function ArticleActionButtons({
  articleId,
  collectionId,
  isSyncedWithElevio,
}: ArticlesTableDropdownsProps) {
  const { showModal } = useModal();

  if (isSyncedWithElevio) return <></>;

  return (
    <>
      <ButtonList.Item
        icon="arrow-right"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          showModal(ArticleMoveModal, {
            articleId,
            collectionId,
          });
        }}
      >
        Move
      </ButtonList.Item>
    </>
  );
}
